<template lang="pug">
#rastreabilidade-raizen
    BaseHeaderRastreabilidade(
        titulo='Nota Fiscal',
        :voltarPara='voltarPara',
        icon='el-icon-plus',
        btnTexto='Inserir Documentos',
    )
    .view-container-base-header
        FiltroRastreabilidade(
            textoPlaceHolder='Pesquisa inteligente (Busque pelo número da nota fiscal)'
            @atualizar-filtro='atualizarFiltro'
        )
        
        .container-totalizadores
            h2 Total de notas fiscais cadastradas
            .totalizadores-lista
                div(v-for="item in this.dadosTotalizadores")
                    BaseCardTotalizadorRastreabilidade(
                        etapa='Notas Fiscais'
                        :texto='item.descricaoTotalizador',
                        :numero='item.totalNotaFiscalCadastrado',
                        :data='item.ultimaAtualizacaoNotaFiscalCadastrado'
                        icone='nota'
                    )

        BotoesDeAcoesRastreabilidade(
            btnPlaceHolder='Inserir Nota Fiscal'
            @btnInserirClicado='openModalArquivo'
            @btnBaixarModeloClicado='baixarModeloArquivo'
        )
      
        TabelaNotaFiscal(
            v-loading='buscandoNotaFiscal',
            :dadosTabela='dadosTabela',
            :paginacao='paginacao',
            :mostrarAcoesVisaoFazenda='false',
            @atualizar-pagina='atualizarPagina',
            @atualizar-tabela='buscarNotaFiscal'
        )
        ModalInsercaoArquivoNotaFiscal(
            :show.sync='showModalArquivo'
            @sucessoUpload='atualizarDadosTela'
            @closeModal='closeModalArquivo'
        )
</template>
    
<script>
import BaseHeaderRastreabilidade from '@/components/rastreabilidadeRaizen/BaseHeaderRastreabilidade';
import FiltroRastreabilidade from '@/components/rastreabilidadeRaizen/FiltroRastreabilidade';
import TabelaNotaFiscal from '@/components/rastreabilidadeRaizen/notaFiscal/TabelaNotaFiscal';
import BotoesDeAcoesRastreabilidade from '@/components/rastreabilidadeRaizen/BotoesDeAcoesRastreabilidade';
import BaseCardTotalizadorRastreabilidade from '@/components/rastreabilidadeRaizen/BaseCardTotalizadorRastreabilidade';

import RastreabilidadeNotaFiscalService from '@/services/RastreabilidadeNotaFiscalService';
import RastreabilidadeDocumentosService from '@/services/RastreabilidadeDocumentosService';

import ModalInsercaoArquivoNotaFiscal from '@/components/rastreabilidadeRaizen/notaFiscal/ModalInsercaoArquivoNotaFiscal';

export default {
    name: 'NotaFiscal',
    components: {
        BaseHeaderRastreabilidade,
        FiltroRastreabilidade,
        TabelaNotaFiscal,
        ModalInsercaoArquivoNotaFiscal,
        BotoesDeAcoesRastreabilidade,
        BaseCardTotalizadorRastreabilidade
    },
    data() {
        return {
            showModalArquivo: false,
            nomeColumn: null,
            voltarPara: true,
            paginacao: {
                    direcao: null,
                    itensPorPagina: 20,
                    ordernarPor: null,
                    pagina: 0,
                    totalPaginas: 0,
                    total: 0
            },
                
            filtros: '',

            dadosTabela: [],

            dadosTotalizadores: [],

            buscandoNotaFiscal: true
        };
    },
    created() {
        this.buscarNotaFiscal(0);
        this.buscarTotalizadoresNotaFiscal();
    },
    methods: {
        btnHeaderClicado: function () {},

        async buscarNotaFiscal(pagina) {
            this.buscandoNotaFiscal = true;
            this.paginacao.pagina = pagina;
            await RastreabilidadeNotaFiscalService.buscar(
                this.filtros,
                this.paginacao
            ).then(({ data }) => {
                    this.dadosTabela = data.itens;
                    this.paginacao = data.paginacao;
                    this.paginacao.pagina += 1;
                    this.buscandoNotaFiscal = false;
            });
        },

        async buscarTotalizadoresNotaFiscal() {
            const { data } =
                await RastreabilidadeNotaFiscalService.buscarTotalizadoresNotaFiscal();
            this.dadosTotalizadores = data;
        },

        async pesquisarNotasFiscal() {
            this.buscandoNotaFiscal = true;
            const { data } =
                await RastreabilidadeNotaFiscalService.pesquisar(this.filtros);
            this.dadosTabela = data.buscarRastreabilidadeNotaFiscalOutputList;
            this.buscandoNotaFiscal = false;
        },

        atualizarFiltro(dados) {
            this.filtros = dados;
            this.buscarNotaFiscal(0);
        },

        atualizarPagina(pagina) {
            this.paginacao.pagina = pagina - 1;
            this.buscarNotaFiscal(pagina);
        },

        openModalArquivo() {
            this.showModalArquivo = true;
        },

        closeModalArquivo() {
            this.showModalArquivo = false;
        },

        atualizarDadosTela() {
            this.buscarNotaFiscal(0);
            this.buscarTotalizadoresNotaFiscal();
        },
        
        ordenar(props) {
                this.paginacao.direcao = props.order;
                this.paginacao.ordernarPor = props.column.label;

                if (props.order === null) this.paginacao.ordernarPor = null;
                this.buscarNotaFiscal(0);
        },

        async baixarModeloArquivo() {
                await RastreabilidadeDocumentosService.baixarModeloCsv('NOTA_FISCAL');
        }
    }
};
</script>
<style lang="scss" scoped>
#rastreabilidade-raizen {
    .box-instrucao {
        float: left;
        height: 39px;
        margin-right: 14px;
        color: #3b3b3b;
        max-width: 269px;
        font-size: 13px;

        span {
            padding-left: 3px;
            color: #1989fa;
            text-decoration-line: underline;
        }
    }

    .container-totalizadores {
        padding: 20px 35px 0px 20px;

        h2 {
            margin-bottom: 10px;
            margin-top: 10px;
            color: var(--black);
            font-weight: bold;
        }
        .totalizadores-lista {
            width: 100%;
            height: 99px;
            margin: 0 auto;
            display: grid;
            gap: 12px;
            grid-template-columns: 33% 33% 33%;
        }

        .totalizadores-bloco {
            width: 32%;
        }
    }
}
</style>
